export const trainingOptions: any = {
  ERROR: {
    color: 'volcano',
    label: 'Failed',
  },
  TRAINING: {
    color: 'orange',
    label: 'Training',
  },
  FINISHED: {
    color: 'green',
    label: 'Trained',
  },
  UNKNOWN: {
    color: 'red',
    label: 'Unknown',
  },
};

export const modelTrainingOptions: any = {
  trained: {
    color: 'green',
    label: 'Trained',
  },
  untrained: {
    color: 'volcano',
    label: 'Not trained',
  },
};

export const inferenceOptions: any = {
  ERROR: {
    color: 'volcano',
    label: 'Failed',
  },
  PROCESSING: {
    color: 'orange',
    label: 'Analysing',
  },
  FINISHED: {
    color: 'green',
    label: 'Analysed',
  },
  UNKNOWN: {
    color: 'red',
    label: 'Unknown',
  },
};

export const tagOptions: any = {
  FINISHED: {
    color: 'green',
    label: 'Done',
  },
  SUCCESS: {
    color: 'green',
    label: 'Done',
  },

  FAILED: {
    color: 'volcano',
    label: 'Error',
  },
  ERROR: {
    color: 'volcano',
    label: 'Error',
  },
  PROCESSING: {
    color: 'orange',
    label: 'Analysing',
  },
};

export const datasetFileStatusOptions: any = {
  DONE: {
    color: 'green',
    label: 'Done',
  },
  PREP_FINISHED: {
    color: 'orange',
    label: 'Analysing',
  },
  PROCESSING: {
    color: 'orange',
    label: 'Analysing',
  },
  ONGOING: {
    color: 'orange',
    label: 'In progress',
  },
  NEW: {
    color: 'red',
    label: 'New',
  },
  SAVED: {
    color: '',
    label: 'Saved',
  },
};

export const datasetFilterOptions: any = {
  DONE: {
    color: 'green',
    label: 'Done',
  },
  ONGOING: {
    color: 'orange',
    label: 'Ongoing',
  },
  NEW: {
    color: 'red',
    label: 'New',
  },
  ALL: {
    color: '',
    label: 'All States',
  },
};

export const inboxFileStatusOptions: any = {
  STAGED: {
    color: 'darkgreen',
    label: 'Staged',
  },
  NEW: {
    color: 'red',
    label: 'New',
  },
};

export const labelOptions: any = {
  notfound: {
    color: '#8c8c8c',
    backgroundColor: '#e8e8e8',
    icon: 'minus',
  },
  incorrect: {
    color: '#fa541c',
    backgroundColor: '#ffd8bf',
    icon: 'exclamation-circle',
  },
  correct: {
    color: '#52c41a',
    backgroundColor: '#d9f7be',
    icon: 'check',
  },
};

export const algorithmMenuDescriptions: any = {
  demo: {
    multiflow:
      'Demo allows you to test multi-models. Upload some documents, choose a model and evaluate the results of the model analysis.',
    keyword:
      'Demo allows you to test keyword detection models. Upload some documents, choose a model and evaluate the results of the model analysis.',
    classification:
      'Demo allows you to test classification models. Upload some documents, choose a model and evaluate the results of the classification.',
    other:
      'Demo allows you to test our base invoice recognition models as well as Custom models. Upload some documents, choose a model and evaluate the results of the model analysis.',
  },
  customization: {
    multiflow: 'End to end flow allows you to create and test a specific document flow.',
    keyword: 'Customisation allows you to train a custom keyword detection model.',
    classification: 'Customisation allows you to train a custom classifier.',
    other:
      'Customisation allows you to customise our base model, to improve the analysis of your specific document templates.',
  },
  flow: {
    multiflow:
      'End to end flow allows you to create and test a specific document flow. Choose a multi-model flow, upload a batch of documents and evaluate the result.',
    classification:
      'End to end flow allows you to create and test a specific document flow. Choose a model, upload a batch of documents and evaluate the result.',
    other:
      'End to end flow allows you to create and test a specific document flow. Choose a model, tick validation rules and upload a batch of documents.',
  },
};
